export default {"src":"/_next/static/media/toggle_plus.ff779a44.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};